import SellerApi from '../SellerApi'
import { ListRolesApiResponse } from '@valuecase/seller-backend'

export default {
  listAvailableRoles: () => SellerApi.get<{ payload: ListRolesApiResponse }>('/auth/roles'),
}
